import { useEffect, useState } from "react";
import './Footer.css';
import axios from "axios";
import { Link, useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const Footer = ({ schoolId = null }) => {

  // Dynamic base URL only for Quick Links
  const baseUrl = schoolId ? `/${schoolId}` : "";

  const { school_slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const [timings, setTimings] = useState([]);

  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${finalSchoolSlug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
          setTimings(res.data.data.timings || []);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-logo">
            <img src="/pictures/tigps_logo.png" alt="TIGPS Logo" />
          </div>
          <p className="footer-description">
            {info?.footer_about_us}
          </p>
        </div>

        <div className="footer-center">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/academics">Academics</Link></li>
            <li><Link to="/life-at-tigps">Life at TIGPS</Link></li>
            <li><Link to="/schools">Campuses</Link></li>
            <li><Link to="https://careers.tigps.in" target="_blank">Career</Link></li>
          </ul>
        </div>

        <div className="footer-right">
          <h3 className="footer-title">Get In Touch</h3>
          <div className="footer-contact">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <p>{info?.address}</p>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone-alt"></i>
              <p>{info?.phone}</p>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <p>{info?.email}</p>
            </div>
          </div>
          <div className="footer-social">
            {info?.facebook_url && (
              <a
                href={info.facebook_url}
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <i className="fab fa-facebook"></i>
              </a>
            )}

            {info?.instagram_url && (
              <a
                href={info.instagram_url}
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <i className="fab fa-instagram"></i>
              </a>
            )}

            {info?.twitter_url && (
              <a
                href={info.twitter_url}
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <i className="fab fa-twitter"></i>
              </a>
            )}

            {info?.youtube_url && (
              <a
                href={info.youtube_url}
                aria-label="Youtube"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <i className="fab fa-youtube"></i>
              </a>
            )}

            {info?.linkedin_url && (
              <a
                href={info.linkedin_url}
                aria-label="LinkidIn"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
